// MonthlyParkingStatisticContainer.js
import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody, Input } from "reactstrap";
import MonthlyParkerStatistic from "pages/Locations/MonthlyParkerStatistic";

const MonthlyParkingStatisticContainer = ({ orders, dateRange, filterOrders, filters }) => {
    const [selectedGranularity, setSelectedGranularity] = useState("Monthly");
    const [selectedLocation, setSelectedLocation] = useState("All Locations");
    const [selectedMode, setSelectedMode] = useState("order");

    useEffect(() => {
        if (dateRange.start && dateRange.end) {
            const start = new Date(dateRange.start);
            const end = new Date(dateRange.end);
            const diffInMonths =
                (end.getFullYear() - start.getFullYear()) * 12 +
                (end.getMonth() - start.getMonth());

            setSelectedGranularity(diffInMonths < 3 ? "Daily" : "Monthly");
        }
    }, [dateRange.start, dateRange.end]);

    return (
        <Row className="mb-3">
            <Col md={12}>
                <Card>
                    <CardBody className="text-center">
                        <Row className="mb-3">
                            {/* Granularity */}
                            <Col md={4} className="d-flex align-items-center justify-content-center">
                                <Input
                                    type="select"
                                    value={selectedGranularity}
                                    onChange={(e) => setSelectedGranularity(e.target.value)}
                                >
                                    <option value="Daily">Daily</option>
                                    <option value="Weekly">Weekly</option>
                                    <option value="Monthly">Monthly</option>
                                </Input>
                            </Col>

                            {/* Location */}
                            <Col md={4} className="d-flex align-items-center justify-content-center">
                                <Input
                                    type="select"
                                    value={selectedLocation}
                                    onChange={(e) => setSelectedLocation(e.target.value)}
                                >
                                    <option>All Locations</option>
                                    {orders.map((loc) => (
                                        <option key={loc.id} value={loc.name}>
                                            {loc.name}
                                        </option>
                                    ))}
                                </Input>
                            </Col>

                            {/* Mode: By Order / By Parker */}
                            <Col md={4} className="d-flex align-items-center justify-content-center">
                                <Input
                                    type="select"
                                    value={selectedMode}
                                    onChange={(e) => setSelectedMode(e.target.value)}
                                >
                                    <option value="order">By Order</option>
                                    <option value="parker">By Parker</option>
                                </Input>
                            </Col>
                        </Row>

                        {/* Statistics Chart */}
                        <MonthlyParkerStatistic
                            orders={orders
                                .flatMap((loc) =>
                                    filterOrders(loc.orders.map((o) => ({ ...o, locationName: loc.name })))
                                )
                                .sort((a, b) => new Date(a.date_created) - new Date(b.date_created))}
                            startDate={dateRange.start}
                            endDate={dateRange.end}
                            granularity={selectedGranularity}
                            locationName={selectedLocation}
                            acceptedOrderStatuses={[
                                ...(filters.succeed ? ["completed"] : []),
                                ...(filters.failed ? ["failed"] : []),
                                ...(filters.pending ? ["pending"] : []),
                                ...(filters.onHold ? ["on-hold"] : []),
                            ]}
                            acceptedPaymentTypes={[
                                ...(filters.stripe ? ["stripe"] : []),
                                ...(filters.cod ? ["cod"] : []),
                                ...(filters.cheque ? ["cheque"] : []),
                                ...(filters.qbo ? ["qbo"] : []),
                            ]}
                            mode={selectedMode}
                        />
                    </CardBody>
                </Card>
            </Col>
        </Row>
    );
};

export default MonthlyParkingStatisticContainer;